import { ReactNode } from 'react'

import { Accordion } from '@tribeplatform/react-ui-kit/Accordion'
import { SimpleDivider } from '@tribeplatform/react-ui-kit/Divider'

import { T } from '../../i18n/components/T.js'

interface Props {
  children: ReactNode
}
export const FieldSettingsSections = ({ children }: Props) => {
  return <div className="space-y-2">{children}</div>
}

interface HocProps {
  children: ReactNode
}
const SectionHOC = (title: JSX.Element, defaultOpen?: boolean) => {
  return ({ children }: HocProps) => {
    return (
      <>
        <SimpleDivider variant="subdued" />
        <Accordion
          defaultOpen={defaultOpen}
          iconAlign="trailing"
          className="-mx-2"
        >
          <Accordion.Button noHover className="hover:text-content-hovered">
            {title}
          </Accordion.Button>
          <Accordion.Panel>
            <div className="space-y-5">{children}</div>
          </Accordion.Panel>
        </Accordion>
      </>
    )
  }
}

FieldSettingsSections.General = SectionHOC(
  <T defaultMessage="General" id="Generics.General" />,
  true,
)
FieldSettingsSections.Permissions = SectionHOC(
  <T defaultMessage="Permissions" id="Generics.Permissions" />,
  true,
)
